'use client'

import { VideoEmbed as VideoEmbedComponent } from '@ccpgames/eve-web-core'
import type { VideoEmbedProps as VideoEmbedComponentProps } from '@ccpgames/eve-web-core'
import type { MediaEmbedFieldsFragment } from '@/graphql/types'
import { NextImageWrapper } from '@/components/shared/NextImageWrapper'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'

interface VideoEmbedProps {
  entry: MediaEmbedFieldsFragment
}

export function VideoEmbed({ entry }: VideoEmbedProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)
  const title = updatedEntry.title ?? ''
  const mediaUrl = updatedEntry.mediaUrl ?? undefined
  const thumbnailUrl = updatedEntry.thumbnail?.url ?? undefined
  const thumbnailAlt = updatedEntry.thumbnail?.description ?? updatedEntry.thumbnail?.title ?? title
  const thumbnail = thumbnailUrl ? (
    <NextImageWrapper src={thumbnailUrl} alt={thumbnailAlt} sizes="100vw" fill />
  ) : undefined

  // This is to default to youtube if no type is provided, which should not happen as it is required field in Contentful
  const type = (updatedEntry.type ?? 'youtube') as VideoEmbedComponentProps['type']
  const twitchParent = typeof window === 'undefined' ? [] : [window.location.hostname]

  if (!mediaUrl) {
    return null
  }

  return (
    <div {...inspectorProps('mediaUrl')}>
      <VideoEmbedComponent
        title={title}
        type={type}
        mediaUrl={mediaUrl}
        loop={updatedEntry.loopVideo ?? false}
        thumbnail={thumbnail}
        twitchParent={twitchParent}
      />
    </div>
  )
}
